import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Grid, Menu, Flex, Drawer, Layout } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../redux/store";
import VerifyModal from "../../Components/Auth/VerifyModal/VerifyModal";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { ROUTES_MAP } from "../../routes/routesMap";
import { buildMenuItems, useMenuSelectedKeys } from "./menuConfig";
import { LanguageSwitcher } from "../../Components/LanguageSwitcher/LanguageSwitcher";
import { ThemeSwitcher } from "../../Components/ThemeSwitcher/ThemeSwitcher";
import { BrandMark } from "../../Components/BrandMark/BrandMark";
import { PageHeading } from "./PageHeading";
import { UserMenu } from "./UserMenu";

const { Header: AntHeader } = Layout;

export const MobileNav: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  const breakpoint = Grid.useBreakpoint();
  const { t } = useTranslation("dashboard");
  const selectedKeys = useMenuSelectedKeys(t, user);

  const [drawerIsOpen, setDrawerOpen] = useState(false);

  const showDrawer = () => {
    setDrawerOpen(true);
  };

  const onDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <AntHeader
      className="header"
      style={{
        height: "auto",
        alignItems: "flex-start",
        background: "transparent",
      }}
    >
      <Flex
        style={{
          flexDirection: "column",
          width: "100%",
          padding: "16px 8px",
        }}
      >
        <Flex
          style={{
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: 12,
            borderBottom: "2px solid var(--st-hairline)",
            marginBottom: 8,
          }}
        >
          <Button
            type="text"
            className="st-mobile-nav__menu-btn"
            aria-label={t("nav.openMenu")}
            onClick={showDrawer}
            style={{ padding: 0 }}
          >
            <MenuOutlined style={{ fontSize: 24 }} />
          </Button>

          <Link
            to={ROUTES_MAP.dashboard.liveStreams}
            style={{
              height: 57,
            }}
          >
            <BrandMark size={40} label="Streaminal" />
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <ThemeSwitcher variant="compact" />
            <LanguageSwitcher variant="compact" />
            <UserMenu />
            <VerifyModal />
          </div>
        </Flex>
        <Flex>
          <div style={{ minWidth: 0, width: "100%" }}>
            <PageHeading />
          </div>
        </Flex>
      </Flex>
      <Drawer
        placement="left"
        width={breakpoint.md ? 500 : "100vw"}
        onClose={onDrawerClose}
        open={drawerIsOpen}
        closeIcon={
          <CloseOutlined
            style={{
              color: "var(--ant-color-text)",
              fontSize: 25,
            }}
          />
        }
        styles={{
          header: {
            padding: "56px 16px",
            background: "transparent",
            borderBottom: "2px solid var(--st-hairline)",
          },
          body: {
            padding: 0,
          },
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          style={{
            backgroundColor: "transparent",
          }}
        >
          {buildMenuItems(t, user).map((item) =>
            item.key.includes("divider") ? (
              <Menu.Divider key={item.key} />
            ) : (
              <Menu.Item
                icon={item.icon}
                key={item.key}
                onClick={onDrawerClose}
                style={{
                  paddingLeft: 12,
                  paddingRight: 12,
                }}
              >
                <Link to={item.key}>{item.title}</Link>
              </Menu.Item>
            )
          )}
        </Menu>
      </Drawer>
    </AntHeader>
  );
};
